import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { EmergencyUnit } from '../../model/unit';

export interface UnitState extends EntityState<EmergencyUnit> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'unit' })
export class UnitStore extends EntityStore<UnitState> {

  constructor() {
    super();
  }

}
